<template>
        <div>
            <h3 v-if="!this.isAddEquipmentMode" class="editor-header px-2">
                {{ $t('roadside_furniture.editor_title')  }}
            </h3>
            <location-deviation v-if="!this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            <div class="px-2">
                <div v-if="!this.isAddEquipmentMode" class="row">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-sm-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('drain.type') }}</span>
                       <select
                           v-model="item.type"
                           class="form-select form-select-sm"
                           :class="{ 'is-invalid': !this.validateIsNumber(item.type) }"
                       >
                           <option value="null" disabled>
                               {{ $t('roadside_furniture.select_type') }}
                           </option>
                           <option
                               v-for="type in getRoadsideFurnitureTypes()"
                               :key="type.value"
                               :value="type.value"
                           >
                               {{ type.name }}
                           </option>
                       </select>
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('drain.material') }}</span>
                       <select
                           v-model="item.material"
                           class="form-select form-select-sm"
                       >
                           <option value="null" disabled>
                               {{ $t('materials.select_material') }}
                           </option>
                           <option
                               v-for="item in getMaterials()"
                               :key="item.value"
                               :value="item.value"
                           >
                               {{ item.name }}
                           </option>
                       </select>
                   </div>
                    <div class="col-sm-4">
                        <condition-selector v-model="item.condition" :required="true"/>
                    </div>
                </div>
                <div class="row">
                    <location-details
                        v-if="!this.isAddEquipmentMode"
                        :lane-data="item.location_specification.lane"
                        :side-data="item.location_specification.side"
                        :track-data="item.location_specification.tracks"
                    />
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.wc_drainage') }}</span>
                       <select
                           v-model="item.wc_drainage"
                           class="form-select form-select-sm"
                       >
                           <option value="null" disabled>
                               {{ $t('roadside_furniture.select_wc_drainage') }}
                           </option>
                           <option
                               v-for="item in getRoadsideFurnitureWCDrainageTypes()"
                               :key="item.value"
                               :value="item.value"
                           >
                               {{ item.name }}
                           </option>
                       </select>
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.inva_wc') }}</span>
                       <input
                           type="checkbox"
                           v-model="item.inva_wc"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.wc_household_water') }}</span>
                       <input
                           type="checkbox"
                           v-model="item.wc_household_water"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.equipment_amount') }}</span>
                       <input
                           id="equipment_amount"
                           v-model="item.equipment_amount"
                           type="number"
                           class="form-control form-control-sm"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.standard_construction') }}</span>
                       <input
                           type="checkbox"
                           v-model="item.standard_construction"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('portal.code') }}</span>
                       <input
                           id="code"
                           v-model="item.code"
                           type="text"
                           class="form-control form-control-sm"
                           min="1"
                       />
                   </div>
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.wc_heating') }}</span>
                       <input
                           type="checkbox"
                           id="precipitation_nest"
                           v-model="item.wc_heating"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.transferable') }}</span>
                       <input
                           type="checkbox"
                           id="transferable"
                           v-model="item.transferable"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.buss_stop_transparency') }}</span>
                       <input
                           type="checkbox"
                           id="buss_stop_transparency"
                           v-model="item.buss_stop_transparency"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.lighting') }}</span>
                       <input
                           type="checkbox"
                           id="lighting"
                           v-model="item.lighting"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.info') }}</span>
                       <input
                           type="text"
                           id="info"
                           v-model="item.info"
                           class="form-control form-control-sm"
                           min="1"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.bath_room') }}</span>
                       <input
                           type="checkbox"
                           id="bath_room"
                           v-model="item.bath_room"
                           :true-value="'true'"
                           :false-value="'false'"
                           class="form-check-input"
                       />
                   </div>
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.buss_stop_wall_amount') }}</span>
                       <input
                           type="number"
                           id="buss_stop_wall_amount"
                           v-model="item.buss_stop_wall_amount"
                           class="form-control form-control-sm"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.buss_stop_code') }}</span>
                       <input
                           type="text"
                           id="buss_stop_code"
                           min="1"
                           v-model="item.buss_stop_code"
                           class="form-control form-control-sm"
                       />
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('roadside_furniture.service_area_code') }}</span>
                       <input
                           type="text"
                           id="service_area_code"
                           min="1"
                           v-model="item.service_area_code"
                           class="form-control form-control-sm"
                       />
                   </div>
                </div>
                <div class="row" v-if="this.isAddEquipmentMode">
                    <div class="col-sm-12">
                        <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                        <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :roadInfo="item"
                            :locationSpecification="item.location_specification"
                        />
                    </div>
               </div>
               <hr class="mb-0">
               <div class="row" v-if="this.isAddEquipmentMode">
                  <div class="col-sm-6 nopads mt-2">
                      <equipment-date
                          :text="$t('velho_equipment.start_date')"
                         v-model="item.created_at"
                      />
                   </div>
               </div>
               <div class="row">
                    <velho-equipment-damages :items="item.equipment_damages"/>
               </div>
                <div class="row">
                    <equipment-actions v-if="!this.isAddEquipmentMode" ref="actions" v-model="item.actions" />
                </div>
                <div class="row">
                    <linked-equipment
                        v-if="item.linked_equipment && item.linked_equipment.length > 0"
                        :linked-equipments="item.linked_equipment"
                    />
                </div>
            </div>
            <velho-editor-buttons
                v-if="!this.isAddEquipmentMode"
                :url="extRoadsideFurnitureUrl"
                :selected-contract="selectedContract"
                :item="item"
                :disabled="loading"
                @close="close"
                @submit="handleSubmit"
                @removalConfirmed="removalConfirmed"
            />
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {velhoHelper} from "@/components/mixins/VelhoMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import {roadsideFurnitureHelper} from "@/components/mixins/RoadsideFurnitureMixin";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDetails from "@/components/velho/LocationDetails.vue";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import VelhoEquipmentDamages from "@/components/velho/VelhoEquipmentDamages";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'RoadsideFurnitureEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDeviation, VelhoEquipmentLocationDetailsEditor, VelhoEquipmentDamages,
        LocationDetails, VelhoEditorButtons, EquipmentActions, ConditionSelector, LinkedEquipment},
    mixins: [mapHelper, conversionModelHelper, restApi, velhoHelper, roadsideFurnitureHelper, velhoValidationMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        handleSubmit: function(url, item, selectedContract, replace = false) {
            if(replace) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(url, item, selectedContract);
            }
        },
        close: function () {
            this.$emit('close')
        },
        isValidForm: function() {
            if(!this.item) { return false }
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateRoadSide(this.item.location_specification.side)) { return false }
            if(!this.validateRoadTracks(this.item.location_specification.tracks)) { return false }
            if(!this.validateIsNumber(this.item.type)) { return false }
            if(!this.validateIsNumber(this.item.condition)) { return false }

            return true
        }
    }
}
</script>

<style scoped>
</style>

